import React, { useEffect, useState } from "react";
import { Card, CardBody, Input } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useInstellingen } from "./Context/InstellingenContext";

const Remark = () => {
	const { userDetails } = useGebruikerContext();
	const { handleFieldChange } = useInstellingen();
	const [description, setDescription] = useState("");

	const updateHandler = (e) => {
		setDescription(e.target.value);
		handleFieldChange("vMemo", e.target.value);
	};

	useEffect(() => {
		setDescription(userDetails?.vMemo ?? "");
	}, [userDetails?.vMemo]);

	return (
		<Card className="main-card">
			<CardBody className="d-flex flex-column">
				<h5 className="mb-4">Opmerking</h5>
				<Input
					type="textarea"
					name="vMemo"
					id="vMemo"
					rows={6}
					value={description}
					onChange={updateHandler}
				/>
			</CardBody>
		</Card>
	);
};

export default Remark;
